export default "__VITE_ASSET__BO$zhvcJ__"